const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_app/album/$id.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
/**
 * Legacy `/album/$id` URLs now resolve to `/work/$id`.
 * 301-redirect preserves bookmarks, external links, and search-engine indexes
 * — old Discogs master IDs are resolved to canonical work catalog IDs first.
 */
export const Route = createFileRoute("/_app/album/$id")({
  loader: lazyFn($$splitLoaderImporter, 'loader')
});